module.exports = __webpack_public_path__ + "static/fonts/DS-DIGI.63f874d1.TTF";